import { ReactNode, useRef } from 'react'
import Draggable from 'react-draggable'
import { Close } from '@mui/icons-material'
import { Box, IconButton, Popover, Stack, SxProps, Theme } from '@mui/material'
import './styles.css'

const emptyChildrenBoxSx = {}

interface Props {
  title: ReactNode

  children: ReactNode

  closePopover: () => void
  anchorEl: HTMLElement | undefined

  paperSx?: SxProps<Theme> | undefined
  childrenBoxSx?: SxProps<Theme> | undefined

  zIndex?: number
  maxWidth?: number
  closeOnClickAway?: boolean
  anchorOrigin?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'right'
  }
  transformOrigin?: {
    vertical: 'top' | 'bottom'
    horizontal: 'left' | 'right'
  }
}

const DraggablePopup = ({
  title,
  children,
  closePopover,
  anchorEl,
  paperSx,
  childrenBoxSx = emptyChildrenBoxSx,
  zIndex = 1202,
  closeOnClickAway = true,
  anchorOrigin = { vertical: 'bottom', horizontal: 'left' } as const,
  transformOrigin = { vertical: 'top', horizontal: 'left' } as const,
}: Props) => {
  const nodeRef = useRef(null)

  const open = !!anchorEl
  return (
    <Draggable handle=".drag-handle" cancel=".popover-content" nodeRef={nodeRef}>
      <Popover
        ref={nodeRef}
        open={open}
        anchorEl={anchorEl}
        onClose={(_, reason) => {
          if (!closeOnClickAway && reason === 'backdropClick') return
          closePopover()
        }}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        hideBackdrop
        disableEnforceFocus
        sx={{
          '.drag-handle': {
            cursor: 'grab',
          },
          zIndex: zIndex,
          // maxWidth,
        }}
        slotProps={{
          root: {
            sx: {
              pointerEvents: 'none',
              // overflowY: 'scroll',
            },
          },
          paper: {
            className: 'drag-handle',
            sx: {
              minWidth: 0,
              minHeight: 0,
              ...paperSx,
            },
          },
        }}
      >
        {open && (
          <Stack
            direction="column"
            sx={{ pointerEvents: 'all' }}
            spacing={1}
            minWidth={300}
            className="drag-handle"
            padding={1}
            // maxWidth={maxWidth}
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              // maxWidth={maxWidth}
              width="100%"
              minWidth={0}
            >
              <Box sx={{ cursor: 'auto', flex: 1, minWidth: 0 }} maxWidth="100%">
                {title}
              </Box>

              <Stack direction="row" spacing={1}>
                <IconButton size="small" onClick={closePopover}>
                  <Close />
                </IconButton>
              </Stack>
            </Box>

            <Box className="popover-content" sx={{ cursor: 'auto', ...childrenBoxSx }}>
              {children}
            </Box>
          </Stack>
        )}
      </Popover>
    </Draggable>
  )
}

export default DraggablePopup
